import React, { useMemo, useState } from 'react';
import {
  ESTATUS_PROSPECTO_CRM,
  ESTATUS_PROSPECTO_LABELS,
  labelFromMap,
} from '../../services/prospectosCrmService';

const ESTATUS_PERDIDA = ['NO_INTERESADO', 'NO_LOCALIZABLE'];

export default function ProspectoStatusModal({ prospecto, onClose, onSubmit, saving = false }) {
  const [form, setForm] = useState({
    estatus: prospecto?.estatus || 'NUEVO',
    comentario: '',
    fechaProximoSeguimiento: '',
    motivoPerdida: '',
  });
  const requiereMotivo = useMemo(() => ESTATUS_PERDIDA.includes(form.estatus), [form.estatus]);

  const update = (event) => {
    const { name, value } = event.target;
    setForm((actual) => ({ ...actual, [name]: value }));
  };

  const submit = (event) => {
    event.preventDefault();
    onSubmit?.({
      estatus: form.estatus,
      comentario: form.comentario.trim() || null,
      fechaProximoSeguimiento: form.fechaProximoSeguimiento || null,
      motivoPerdida: form.motivoPerdida.trim() || null,
    });
  };

  return (
    <div className="crm-prospectos-modal-overlay" role="presentation" onMouseDown={onClose}>
      <section className="crm-prospectos-modal" role="dialog" aria-modal="true" onMouseDown={(event) => event.stopPropagation()}>
        <div className="crm-prospectos-modal-head">
          <div>
            <p className="crm-prospectos-eyebrow">Prospecto</p>
            <h2>Cambiar estatus</h2>
          </div>
          <button type="button" onClick={onClose} disabled={saving} aria-label="Cerrar">x</button>
        </div>
        <form onSubmit={submit} className="crm-prospectos-modal-body">
          <label>
            <span>Estatus</span>
            <select name="estatus" value={form.estatus} onChange={update}>
              {ESTATUS_PROSPECTO_CRM.map((estatus) => (
                <option key={estatus} value={estatus}>{labelFromMap(ESTATUS_PROSPECTO_LABELS, estatus)}</option>
              ))}
            </select>
          </label>
          <label>
            <span>Comentario</span>
            <textarea name="comentario" value={form.comentario} onChange={update} rows="3" />
          </label>
          <label>
            <span>Fecha de proximo seguimiento</span>
            <input name="fechaProximoSeguimiento" type="datetime-local" value={form.fechaProximoSeguimiento} onChange={update} />
          </label>
          {requiereMotivo ? (
            <label>
              <span>Motivo</span>
              <textarea name="motivoPerdida" value={form.motivoPerdida} onChange={update} rows="3" />
            </label>
          ) : null}
          <div className="crm-prospectos-modal-actions">
            <button type="submit" className="is-primary" disabled={saving}>{saving ? 'Guardando...' : 'Guardar estatus'}</button>
            <button type="button" onClick={onClose} disabled={saving}>Cancelar</button>
          </div>
        </form>
      </section>
    </div>
  );
}
